module.exports = __webpack_public_path__ + "img/kf.f3334533.png";